import { RadioGroup } from "devextreme-react/radio-group";
import React, { useMemo, useRef } from "react";
export default function CheckRadioButton({ className, elementAttr, item, checked, onCheckedChanged }) {
    const valueChangedRef = useRef(false);
    const items = useMemo(() => [item], [item]);
    const resultElementAttr = useMemo(() => {
        const result = { ...(elementAttr || {}) };
        if (className)
            result.class = className;
        return result;
    }, [className, elementAttr]);
    return (React.createElement(RadioGroup, { elementAttr: resultElementAttr, items: items, displayExpr: "Name", valueExpr: "Key", value: checked ? item.Key : undefined, onOptionChanged: ({ fullName, value }) => {
            if (fullName !== "isActive" || value === checked)
                return;
            if (!value && valueChangedRef.current) {
                valueChangedRef.current = false;
                return;
            }
            onCheckedChanged && onCheckedChanged(item, value);
        }, onValueChanged: ({ event }) => {
            if (!checked || (checked && event)) {
                valueChangedRef.current = true;
            }
        } }));
}
